import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Nav from "../Components/Nav";
import { onAuthStateChanged } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";
import { auth, db } from "../config";
function DepositHistory() {
  const [deposits, setDeposits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const q = query(
            collection(db, "deposits"),
            where("userId", "==", user.uid)
          );
          const querySnapshot = await getDocs(q);
          const depositData = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          // Sort newest to oldest
          depositData.sort(
            (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
          );
          setDeposits(depositData);
        } catch (error) {
          console.error("Error fetching deposits:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setDeposits([]);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div>
      <Helmet>
        <script src="forthfunded/popper.min.js" />
        <script src="forthfunded/bootstrap.bundle.min.js" />
        <script src="forthfunded/defaultmenu.min.js" />
        <script src="forthfunded/waves.min.js" />
        <script src="forthfunded/sticky.js" />
        <script src="forthfunded/simplebar.min.js" />
        <script src="forthfunded/simplebar.js" />
        <script src="forthfunded/pickr.es5.min.js" />
        <script src="forthfunded/apexcharts.min.js" />
        <script src="forthfunded/crypto-dashboard.js" />
        <script src="forthfunded/custom-switcher.min.js" />
        <script src="forthfunded/custom.js" />
      </Helmet>


      <div className="page">
        <Header />
        <Nav />
        <div className="main-content app-content">
          <div className="container-fluid">
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <h1 className="page-title fw-semibold fs-18 mb-0">
                Deposit History
              </h1>
              <div className="ms-md-1 ms-0">
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">Dashboard</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Deposit
                    </li>
                  </ol>
                </nav>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div className="table-responsive">
                      {loading ? (
                        <p>Loading deposit history...</p>
                      ) : deposits.length === 0 ? (
                        <p>No deposit history found.</p>
                      ) : (
                        <table className="table table-bordered text-nowrap w-100">
                          <thead>
                            <tr>
                              <th>Amount</th>
                              <th>Method</th>
                              <th>Status</th>
                              <th>Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {deposits.map((deposit) => (
                              <tr key={deposit.id}>
                                <td>${deposit.amount}</td>
                                <td>{deposit.method}</td>
                                <td>{deposit.status}</td>
                                <td>
                                  {new Date(deposit.timestamp).toLocaleString()}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="footer mt-auto py-3 bg-white text-center">
          {/* Footer content */}
        </footer>
      </div>
    </div>
  );
}

export default DepositHistory;
